"use strict";
// ? https://github.com/emotion-js/emotion/issues/2193
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    shouldForwardProp: (propName) => propName !== 'theme' && !propName.startsWith('$'),
};
